import { Close } from "@mui/icons-material";
import {
  Divider,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useCallback, useState } from "react";
import { desktopSx } from "src/utils/styles/modalStyles";
import ExistingStrengthForm from "../ExistingStrengthForm";
import NewStrengthForm from "../NewStrengthForm";

interface Props {
  open: boolean;
  onClose: () => void;
}

const tabs = ["Existing", "New"];

const AddStrengthModal = ({ onClose, open }: Props) => {
  const [value, setValue] = useState<number>(0);

  const handleChange = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    },
    [],
  );

  const handleClose = useCallback(() => {
    localStorage.removeItem("open-medication-strength");
    onClose();
  }, [onClose]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Stack sx={desktopSx}>
        <Stack gap={2}>
          <Stack gap={1}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h5" component="h5" fontWeight={700}>
                Add Strength
              </Typography>
              <IconButton onClick={handleClose} sx={{ p: 0 }}>
                <Close fontSize="medium" />
              </IconButton>
            </Stack>
            <Divider sx={{ backgroundColor: "#000000" }} />
          </Stack>
          <Tabs value={value} onChange={handleChange}>
            {tabs.map((t) => (
              <Tab label={t} key={t} />
            ))}
          </Tabs>
          {value === 0 ? (
            <ExistingStrengthForm onClose={onClose} />
          ) : (
            <NewStrengthForm onClose={onClose} />
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default AddStrengthModal;
